
import React, { useState, useEffect, useRef } from 'react';
import useCutShapes from '../Admin/useCutShapes';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import useCategories from '../Admin/useCategories';

import '../Admin/Admin.scss';

const Categorysection = () => {
  const { categories, loding, err, fetchcategories } = useCategories()
  const [isCategoriesDropdownVisible, setIsCategoriesDropdownVisible] = useState(false);


  // Refs to detect clicks outside the dropdowns
  const categoriesRef = useRef(null);
  const dropdownsRef = useRef(null);

  // Show dropdowns
  const toggleCategoriesDropdown = () => setIsCategoriesDropdownVisible(true);

  // Hide dropdowns
  const hideCategoriesDropdown = () => setIsCategoriesDropdownVisible(false);

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoriesRef.current && !categoriesRef.current.contains(event.target) &&
        dropdownsRef.current && !dropdownsRef.current.contains(event.target)
      ) {
        setIsCategoriesDropdownVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  


  return (
    <>
      <div id="categories">
        <div id='pp'>

          <button>
            <Link className='cat-link' to={'/'}>
              Home
            </Link>
          </button>


          <button
            className='cat-link'
            ref={categoriesRef}
            onClick={() => {
              if (!isCategoriesDropdownVisible) {
                toggleCategoriesDropdown();
              } else {
                hideCategoriesDropdown();
              }
            }}
          >
            All Products
          </button>

          {/* All Products dropdown */}
          {categories.map((category) => (

            <button>
              <Link className='cat-link' to={`/category?category=${category.category_code}`}>{category.category_name}  </Link>
            </button>

          ))}

        </div>

        {isCategoriesDropdownVisible && (
          <div
            ref={dropdownsRef}
            className="dropdown-menux"
            id="dropdown-menu-categories"
            onClick={() => {
              if (!isCategoriesDropdownVisible) {
                toggleCategoriesDropdown();
              } else {
                hideCategoriesDropdown();
              }
            }}
          >
            <span style={{ "color": "#b63f23" }}><Link className='cat-link' to={`/allproducts`}>All Products</Link></span>
            {categories.map((category, index) => (
              <span key={index}>
                <Link
                  onClick={() => {
                    setIsCategoriesDropdownVisible(false);
                  }}
                  className="link cat-link" to={`/category?category=${category.category_code}`}>
                  {category.category_name}
                </Link>
              </span>
            ))}
          </div>
        )}
      </div><br></br>

    </>
  );
};

export default Categorysection;


